<div class="marquee-container">
  @if (extendedItems.length > 0) {
  <div class="marquee-content" [style.--marquee-duration]="duration + 's'">
    @for (item of extendedItems; track $index) {
    <div class="flex items-center space-x-2">
      @if (typeof item === 'string') {
      <span class="text-lg font-medium">{{ item }}</span>
      } @else {
      <mat-icon class="w-6 h-6" [svgIcon]="item.icon"></mat-icon>
      <span class="text-lg font-medium">{{ item.text }}</span>
      }
    </div>
    }
  </div>
  }
</div>
